import moment from 'moment';
import { throwErrorMessage } from '../../lib/error_helper';
import { fetchWithTimeout } from '../../lib/fetch_wrapper';
import { GET_ABSENCES, GET_ABSENCES_ACTIVITY_TYPES, IS_LOADING, SET_ABSENCE_CREATION_FIELDS, SET_ABSENCE_DETAILS, SET_EDITION_STATE, SET_REDIRECT_URL, SET_STATUS_FILTER, SWITCH_ABSENCES_MODE } from "./absencesConstants";

export function switchAbsenceModeAction(absencesToValidateMode) {
    return {
        type: SWITCH_ABSENCES_MODE,
        absencesToValidateMode: absencesToValidateMode
    };
}

export function setStatusFilterAction(statusFilter) {
    return {
        type: SET_STATUS_FILTER,
        statusFilter: statusFilter,
    }
}

export function setAbsenceDetailsAction(absenceDetails) {
    return {
        type: SET_ABSENCE_DETAILS,
        absenceDetails: absenceDetails
    };
}

export function setAbsenceCreationFieldsAction(absenceCreationFields) {
    return {
        type: SET_ABSENCE_CREATION_FIELDS,
        absenceCreationFields: absenceCreationFields,
    }
}

export function getActivityTypesAction(activityTypes) {
    return {
        type: GET_ABSENCES_ACTIVITY_TYPES,
        activityTypes: activityTypes,
    }
}

export function setRedirectUrlAction(url) {
    return {
        type: SET_REDIRECT_URL,
        url: url,
    }
}

export function getAbsencesAction(absences) {
    return {
        type: GET_ABSENCES,
        absences: absences,
    }
}

export function absencesIsLoading(value) {
    return {
        type: IS_LOADING,
        info: 'Récupération des absences',
        isLoading: value
    };
}

export function setEditionStateAction(state) {
    return {
        type: SET_EDITION_STATE,
        state,
    }
}

export function getDefaultAbsenceDetail(defaultActivityTypeId) {
    return {
        id: 0,
        date: null,
        morning: true,
        afternoon: true,
        morning_type_id: defaultActivityTypeId,
        afternoon_type_id: defaultActivityTypeId,
        deleted: false,
    };
}

export function getMyAbsences(empId) {
    return (dispatch) => {
        dispatch(getAbsencesAction([]))
        dispatch(absencesIsLoading(true));
        const headers = new Headers({ 'Content-Type': 'application/json' });
        fetchWithTimeout('/api/v1/absences/get_my_requests/' + empId, {
            method: 'GET',
            headers: headers
        })
            .then((response) => {
                dispatch(absencesIsLoading(false));
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then((response) => response.json())
            .then((myAbsences) => {
                myAbsences.forEach(a =>
                    a.date_ids.map(d => {
                        d.date = moment(d.date);
                        return d;
                    })
                )
                dispatch(getAbsencesAction(myAbsences.filter(a => a.date_ids.length > 0)))
            })
            .catch((err) => {
                console.error("Erreur : absencesActions - getMyAbsences", err)
                dispatch(throwErrorMessage({
                    errorObject: err,
                    title: "Erreur",
                    message: "Erreur lors de la récupération de mes absences !",
                }))
                dispatch(absencesIsLoading(false));
            });
    }
}

export function getAbsencesToValidate(empId) {
    return (dispatch) => {
        dispatch(getAbsencesAction([]))
        dispatch(absencesIsLoading(true));
        const headers = new Headers({ 'Content-Type': 'application/json' });
        fetchWithTimeout('/api/v1/absences/get_requests_to_validate/' + empId, {
            method: 'GET',
            headers: headers
        })
            .then((response) => {
                dispatch(absencesIsLoading(false));
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then((response) => response.json())
            .then((absencesToValidate) => dispatch(getAbsencesAction(absencesToValidate.filter(a => a.date_ids.length > 0))))
            .catch((err) => {
                console.error("Erreur : absencesActions - getAbsencesToValidate", err)
                dispatch(throwErrorMessage({
                    errorObject: err,
                    title: "Erreur",
                    message: "Erreur lors de la récupération des absences à valider !",
                }))
                dispatch(absencesIsLoading(false));
            });
    }
}

export function getCounters(empId, details, defaultAbsenceTypeId, userId) {
    return (dispatch) => {
        dispatch(absencesIsLoading(true));
        const headers = new Headers({ 'Content-Type': 'application/json' });
        fetchWithTimeout('/api/v1/absences/get_holidays_counters/' + userId + '/' + empId, {
            method: 'GET',
            headers: headers
        })
            .then((response) => {
                dispatch(absencesIsLoading(false));
                if (!response.ok) {
                    throw Error(response.statusText);
                }

                return response;
            })
            .then((response) => response.json())
            .then((counters) => {
                dispatch(setAbsenceCreationFieldsAndGenerateDetails(null, empId, defaultAbsenceTypeId, details, 'new', counters[empId], moment().startOf('day'), moment().startOf('day'), "", userId))
            }).catch((err) => {
                console.error("Erreur : absencesActions - getCounters", err)
                dispatch(throwErrorMessage({
                    errorObject: err,
                    title: "Erreur",
                    message: "Erreur lors de la récupération des compteurs d'absence !",
                }))
                dispatch(absencesIsLoading(false));
            });
    }
}

export function setAbsenceCreationFields(id, employeeId, defaultAbsenceTypeId, details, status, counters, date_from, date_to, comment) {
    return (dispatch) => {
        let absenceCreationFields = { employeeId, defaultAbsenceTypeId, status, id, counters, date_from, date_to, comment, nbDays: getDaysNumber(details) }
        dispatch(setAbsenceCreationFieldsAction(absenceCreationFields))
        dispatch(setAbsenceDetails(details));
    }
}

export function setAbsenceCreationFieldsAndGenerateDetails(id, employeeId, defaultAbsenceTypeId, details, status, counters, dateStart, dateEnd, comment, userId) {
    return (dispatch) => {
        dispatch(getWorkingDaysAndGenerateDetails(id, employeeId, defaultAbsenceTypeId, details, status, counters, dateStart, dateEnd, comment, userId));
    }
}

export function getAbsencesActivityTypes(absenceCreationFields, details, activeUser, callGetCounters = false) {
    return (dispatch) => {
        const headers = new Headers({ 'Content-Type': 'application/json' });
        fetchWithTimeout('/api/v2/weekly_report_activity_type/all/' + true + '/' + false, {
            method: 'GET',
            headers: headers
        })
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then((response) => response.json())
            .then((activityTypes) => {
                dispatch(getActivityTypesAction(activityTypes))

                if (activityTypes.length > 0) {
                    absenceCreationFields.defaultAbsenceTypeId = activityTypes.filter(at => at.report_type === activeUser.weekly_report_type)[0].id;
                    dispatch(setAbsenceCreationFieldsAction(absenceCreationFields));
                    dispatch(setAbsenceDetails(details));
                    if (callGetCounters){
                        dispatch(getCounters(activeUser.emp_id, [], absenceCreationFields.defaultAbsenceTypeId, activeUser.id));
                    }
                }
            }).catch((err) => {
                console.error("Erreur : absencesActions - getAbsencesActivityTypes", err);
                dispatch(throwErrorMessage({
                    errorObject: err,
                    title: "Erreur",
                    message: "Erreur lors de la récupération des types d'activité !",
                }))
            });
    }
}

function getWorkingDaysAndGenerateDetails(id, employeeId, defaultAbsenceTypeId, details, status, counters, dateStart, dateEnd, comment, userId) {
    return (dispatch) => {
        const headers = new Headers({ 'Content-Type': 'application/json' });
        fetchWithTimeout('/api/v1/absences/get_non_working_days/' + userId + '/' + dateStart.format('YYYY-MM-DD') + '/' + dateEnd.format('YYYY-MM-DD'), {
            method: 'GET',
            headers: headers
        })
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then((response) => response.json())
            .then((nonWorkingDays) => {
                let details = [];

                let currentDate = moment(dateStart);
                let index = 0;

                let datesMatch = (nwd) => moment(nwd).format("YYYY-MM-DD") === currentDate.format("YYYY-MM-DD");

                while (currentDate <= dateEnd) {
                    //Jour férié
                    if (nonWorkingDays.filter(datesMatch).length > 0) {
                        currentDate.add(1, 'days');
                        continue
                    }

                    //Samedi ou dimanche
                    if (currentDate.day() === 0 || currentDate.day() === 6) {
                        currentDate.add(1, 'days');
                        continue
                    }

                    details.push({
                        id: index,
                        date: moment(currentDate),
                        morning: true,
                        afternoon: true,
                        morning_type_id: defaultAbsenceTypeId,
                        afternoon_type_id: defaultAbsenceTypeId,
                        deleted: false,
                    });

                    currentDate = currentDate.add(1, 'days');
                    index++;
                }

                dispatch(setAbsenceCreationFields(id, employeeId, defaultAbsenceTypeId, details, status, counters, dateStart, dateEnd, comment));

            }).catch((err) => {
                console.error("Erreur : absencesActions - getWorkingDaysAndGenerateDetails", err);
                dispatch(throwErrorMessage({
                    errorObject: err,
                    title: "Erreur",
                    message: "Erreur lors de la récupération des jours travaillés !",
                }))
            });
    }
}

export function switchAbsenceMode(currentValue, activeUser) {
    return (dispatch) => {
        if (currentValue)
            currentValue = false;
        else
            currentValue = true;

        dispatch(switchAbsenceModeAction(currentValue))
        dispatch(getAbsences(currentValue, activeUser))
    }
}

export function getAbsences(absencesToValidateMode, activeUser) {
    return (dispatch) => {
        if (absencesToValidateMode) {
            dispatch(getAbsencesToValidate(activeUser.id));
        } else {
            dispatch(getMyAbsences(activeUser.id));
        }
    }
}

export function setStatusFilter(statusFilter) {
    return (dispatch) => {
        dispatch(setStatusFilterAction(statusFilter))
    }
}

export function setAbsenceDetails(absenceDetails, absenceCreationFields) {
    return (dispatch) => {
        if (absenceCreationFields) {
            absenceCreationFields.nbDays = getDaysNumber(absenceDetails);
            dispatch(setAbsenceCreationFieldsAction(absenceCreationFields))
        }

        dispatch(setAbsenceDetailsAction(absenceDetails))
    }
}


export function redirect(url) {
    return (dispatch) => {
        dispatch(setRedirectUrlAction(url));
    }
}

export function setEditionState(creationMode, updateMode, validationMode) {
    return (dispatch) => {
        dispatch(setEditionStateAction({
            creationMode,
            updateMode,
            validationMode,
        }));
    }
}

export function selectAbsence(absence) {
    return (dispatch) => {

        let firstActivityTypeId;
        let dateStart = absence.date_ids[0].date;
        let dateEnd = absence.date_ids[absence.date_ids.length - 1].date;

        if (absence.date_ids[0].morning)
            firstActivityTypeId = absence.date_ids[0].morning_type_id;
        else
            firstActivityTypeId = absence.date_ids[0].afternoon_type_id;

        dispatch(setAbsenceCreationFields(absence.id, absence.emp_id, firstActivityTypeId, absence.date_ids, absence.state, absence.holidays_counters, dateStart, dateEnd, absence.comment))
    }
}

export function resetAbsenceSelection(employeeId, userId, details = []) {
    return (dispatch) => {
        dispatch(setAbsenceCreationFieldsAndGenerateDetails(null, employeeId, 0, details, 'new', null, moment().startOf('day'), moment().startOf('day'), "", userId))
    }
}

export function getDaysNumber(details) {

    let nbDays = 0;

    details.forEach((d) => {
        if (d.morning)
            nbDays += 0.5;

        if (d.afternoon)
            nbDays += 0.5;
    })

    return nbDays;
}

export function getStatusLabel(status) {
    if (status === "confirmed")
        return "Confirmé";
    else if (status === "new")
        return "Nouveau";
    else if (status === "validated")
        return "Validé";
    else if (status === "cancelled")
        return "Annulé";
    else if (status === "refused")
        return "Refusé";
}

export function getStatusList() {
    return [
        "confirmed",
        "new",
        "validated",
        "cancelled",
        "refused",
    ];
}

export function getColorFromStatusLabel(status, lowlight) {
    if (lowlight)
        return "grey";

    if (status === "confirmed")
        return "yellow";
    else if (status === "new")
        return "blue";
    else if (status === "validated")
        return "green";
    else if (status === "cancelled")
        return "black";
    else if (status === "refused")
        return "red";
    else
        return;
}

export function getIconNameFromStatusLabel(status) {
    if (status === "confirmed")
        return "schedule";
    else if (status === "new")
        return "edit";
    else if (status === "validated")
        return "thumb_up";
    else if (status === "cancelled")
        return "backspace";
    else if (status === "refused")
        return "thumb_down";
}

export function getUnitLabel(unit) {
    if (unit === "days")
        return "jours";
    else if (unit === "hours")
        return "heures";
}

export function getMainWorkflowStatus(status) {
    let allStatus = ['new',]

    if (status === "cancelled") {
        allStatus.push('cancelled');
        return allStatus;
    }

    allStatus.push('confirmed');

    if (status === "refused") {
        allStatus.push('refused');
        return allStatus;
    }

    allStatus.push('validated');

    return allStatus;
}

export function isEditIcon(status) {
    return status === 'new';
}
